/**
 * SEO工具函数
 * 用于动态更新页面的meta标签
 */

// 默认SEO配置
const defaultSEO = {
  title: '智维驿 - 智能设备后市场服务数智化云平台',
  description: '智维驿是专业的智能设备后市场服务数智化云平台，提供制卡设备、智能设备、机器人、无人机、新能源设备、智能家电等各类设备的维修、保养、管理、租赁等服务。',
  keywords: '智维驿,智能设备维修,制卡设备维修,设备维修服务,机器人维修,无人机维修,新能源设备维修,智能家电维修,设备保养,设备管理,设备租赁',
  image: '/logo.png'
}

/**
 * 更新页面SEO信息
 * @param {Object} seo - SEO配置对象
 * @param {string} seo.title - 页面标题
 * @param {string} seo.description - 页面描述
 * @param {string} seo.keywords - 页面关键词
 * @param {string} seo.image - 页面图片
 */
export function updateSEO(seo = {}) {
  const config = { ...defaultSEO, ...seo }
  
  // 更新title
  if (config.title) {
    document.title = config.title
  }
  
  // 更新或创建meta标签
  updateMetaTag('description', config.description)
  updateMetaTag('keywords', config.keywords)
  
  // 更新Open Graph标签
  updateMetaTag('og:title', config.title, 'property')
  updateMetaTag('og:description', config.description, 'property')
  updateMetaTag('og:image', config.image, 'property')
  
  // 更新Twitter标签
  updateMetaTag('twitter:title', config.title, 'property')
  updateMetaTag('twitter:description', config.description, 'property')
  updateMetaTag('twitter:image', config.image, 'property')
}

/**
 * 更新或创建meta标签
 * @param {string} name - meta标签的name或property
 * @param {string} content - meta标签的content
 * @param {string} attr - 属性类型：'name' 或 'property'
 */
function updateMetaTag(name, content, attr = 'name') {
  if (!content) return
  
  let meta = document.querySelector(`meta[${attr}="${name}"]`)
  
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute(attr, name)
    document.head.appendChild(meta)
  }
  
  meta.setAttribute('content', content)
}

/**
 * 更新canonical链接
 * @param {string} url - 规范URL
 */
export function updateCanonical(url) {
  if (!url) return
  
  let link = document.querySelector('link[rel="canonical"]')
  
  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }
  
  link.setAttribute('href', url)
}

